import React, { useState, useEffect } from 'react'
import { Form, Alert } from 'react-bootstrap'

interface ConfirmationInputProps {
    message: string
    confirmText: string
    onValidChange: (isValid: boolean) => void
    warningMessage?: string
}

const ConfirmationInput: React.FC<ConfirmationInputProps> = ({
    message,
    confirmText,
    onValidChange,
    warningMessage
}) => {
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        onValidChange(inputValue === confirmText)
    }, [inputValue, confirmText, onValidChange])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value)
    }

    return (
        <>
            <p>{message}</p>
            {warningMessage && (
                <Alert variant="warning" className="py-2">
                    <small>{warningMessage}</small>
                </Alert>
            )}
            <Form.Group className="mt-3">
                <Form.Label>
                    Please type <strong>{confirmText}</strong> to confirm:
                </Form.Label>
                <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    placeholder={`Type "${confirmText}" here`}
                    autoFocus
                />
                {inputValue && inputValue !== confirmText && (
                    <Form.Text className="text-danger">
                        Text doesn't match. Please type exactly: {confirmText}
                    </Form.Text>
                )}
            </Form.Group>
        </>
    )
}

export default ConfirmationInput